import { inject } from 'vue'
import available_currencies from '@/vendors/multi_currency/available_currencies'
import { get as _get } from 'lodash'

class MultiCurrency {
  getDefaultValue (value = 0) {
    return available_currencies.reduce((currencies, currency) => ({ ...currencies, [currency]: _get(value, currency, value) }), {})
  }
}

const MultiCurrencySymbol = Symbol()
const multi_currency = new MultiCurrency()

export default multi_currency

export const createMultiCurrency = {
  install: app => app.provide(MultiCurrencySymbol, multi_currency)
}

export function useMultiCurrency () {
  return inject(MultiCurrencySymbol)
}
